module.exports = __webpack_public_path__ + "static/media/pompy-B.6b3e834d.svg";